import { extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { mergeRefs } from '@costar-ui/utils';
import React__default, { forwardRef, useRef } from 'react';
import { useFocusable } from 'react-aria';
import Slot from './slot.esm.js';

// Note having a HoverSlot within a HoverSlot is causing issues for tooltip anchor
var HoverSlot = /*#__PURE__*/forwardRef(function HoverSlot(props, ref) {
  var localRef = useRef(null);
  var _useFocusable = useFocusable(props, localRef),
    focusableProps = _useFocusable.focusableProps;
  return /*#__PURE__*/React__default.createElement(Slot, _extends({
    ref: mergeRefs(ref, localRef)
  }, _objectSpread2(_objectSpread2({}, props), focusableProps)));
});
HoverSlot.displayName = 'HoverSlot';
var HoverSlot$1 = HoverSlot;

export { HoverSlot$1 as default };
//# sourceMappingURL=hover-slot.esm.js.map
